import React, { useMemo } from 'react';
import { Box, CircularProgress, Grid, Typography } from '@material-ui/core';
import { Section } from './components';
import { makeStyles } from '@material-ui/core/styles';
import { useCompany } from 'contexts/CompanyContext';
import lock from '_assets/parameters/lock.svg';
import bell from '_assets/parameters/bell.svg';
import bill from '_assets/parameters/bill.svg';
import arrobase from '_assets/parameters/arrobase.svg';
import invite from '_assets/parameters/invite.svg';
import ecommerce from '_assets/parameters/ecommerce.svg';
import creditCard from '_assets/parameters/credit-card-2.svg';
import team from '_assets/parameters/team-2.svg';
import location from '_assets/parameters/location.svg';
import note from '_assets/parameters/note.svg';
import signal from '_assets/parameters/signalAlt.svg';
import routes from 'config/routes';

const manager = [
  {
    title: 'Connexion et Informations',
    path: routes.parameters.security.root,
    logo: lock,
  },
  {
    title: 'Notifications',
    path: routes.parameters.notifications.root,
    logo: bell,
  },
  {
    title: 'Inviter des amis',
    path: routes.parameters.invite.root,
    logo: invite,
  },
];

const company = [
  {
    title: 'Gestion Entreprise',
    path: routes.parameters.companies.root,
    logo: ecommerce,
  },
  {
    title: 'Banque et Assurance',
    path: routes.parameters.bank.root,
    logo: creditCard,
  },
  {
    title: 'Factures',
    path: routes.parameters.bills.root,
    logo: bill,
  },
  {
    title: 'Note et Descriptif',
    path: routes.parameters.noteDescription.root,
    logo: note,
  },
  {
    title: 'Equipe',
    path: routes.parameters.team.root,
    logo: team,
  },
  {
    title: 'Lieux des prestations',
    path: routes.parameters.location.root,
    logo: location,
  },
  {
    title: 'Réseaux sociaux',
    path: routes.parameters.socialNetworks.root,
    logo: arrobase,
  },
  {
    title: 'Canaux de Distribution',
    path: null,
    logo: signal,
  },
];

const useStyles = makeStyles(() => ({
  title: {
    lineHeight: '58.85px',
  },
}));

function Parameters() {
  const classes = useStyles();
  const { companySteps, companyStepLoading } = useCompany();

  const { companyCards, managementCards } = useMemo(() => {
    if (!companySteps) return { companyCards: [...company], managementCards: [...manager] };

    const compCards = company.map((c) => ({ ...c, enabled: true }));
    const manCards = manager.map((m) => ({ ...m, enabled: true }));

    if (!companySteps.description_created) {
      const index = compCards.findIndex((c) => c.path === routes.parameters.noteDescription.root);
      compCards[index] = { ...compCards[index], enabled: false };
    }

    if (!companySteps.employee_created) {
      const index = compCards.findIndex((c) => c.path === routes.parameters.team.root);
      compCards[index] = { ...compCards[index], enabled: false };
    }

    const index = compCards.findIndex((c) => !c.path);
    compCards[index] = { ...compCards[index], enabled: false };

    return { companyCards: compCards, managementCards: manCards };
  }, [companySteps]);

  if (!!companyStepLoading)
    return (
      <Box style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress size={100} />
      </Box>
    );

  return (
    <Grid container spacing={2}>
      <Grid container item xs={12} justifyContent="center">
        <Typography component="h2" variant="h1" className={classes.title}>
          Paramètres du gestionnaire
        </Typography>
      </Grid>

      <Grid container item xs={12} justifyContent="center">
        <Grid container item xs={12} d={10} lg={9} xl={6} justifyContent="center" style={{ paddingBottom: '5%' }}>
          {managementCards.map((card) => (
            <Grid container item xs={12} sx={12} sm={7} md={5} lg={3} justifyContent="center">
              <Section key={card.title} {...card} />
            </Grid>
          ))}
        </Grid>
      </Grid>

      <Grid container item xs={12} justifyContent="center">
        <Typography component="h2" variant="h1" className="title">
          Paramètres de l'entreprise
        </Typography>
      </Grid>

      <Grid container item xs={12} justifyContent="center">
        <Grid container item xs={12} md={10} lg={9} xl={6} justifyContent="flex-start">
          {companyCards.map((card) => (
            <Grid container item xs={12} sm={6} md={4} lg={3} justifyContent="center" style={{ marginBottom: '10px' }}>
              <Section key={card.title} {...card} />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Parameters;
